export default __webpack_public_path__ + "static/media/Look at me II.fc86a192.jpg";